var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 121,
    viewBox: "0 0 110 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 55.2931,
    cy: 53.6779,
    r: 53.6779,
    fill: "url(#paint0_linear_3854_28685)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_3854_28685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2655 37.1748C25.5482 34.1227 27.441 31.067 30.4932 30.3498L56.9738 24.1269C58.7133 23.7181 60.5437 24.1522 61.9144 25.2985L66.995 29.5474L72.9258 33.5209C74.1184 34.3199 74.964 35.541 75.2924 36.9385L83.6017 72.2976C84.3189 75.3497 82.4261 78.4054 79.374 79.1226L43.9129 87.4559C40.8608 88.1731 37.8051 86.2803 37.0878 83.2281L26.2655 37.1748Z",
    fill: "url(#paint1_linear_3854_28685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8613 45.3047L66.107 38.6671",
    stroke: "white",
    strokeWidth: 4.35226,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8516 53.7773L54.6805 50.2926",
    stroke: "white",
    strokeWidth: 4.35226,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8017 35.1254L57.5151 25.3947C57.2317 24.189 58.5208 23.2242 59.5977 23.836L66.9923 28.0369C67.8399 28.5185 68.6248 29.103 69.329 29.7772L74.531 34.7573C75.3444 35.536 74.9704 36.9064 73.8742 37.164L66.0581 39.0008C63.2603 39.6583 60.4592 37.9232 59.8017 35.1254Z",
    fill: "#E1E1E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_3854_28685",
    x: -0.0002985,
    y: 4.06325,
    width: 109.868,
    height: 116.188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5.80302,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3854_28685"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.52839
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.1553
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3854_28685"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.35226
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.80302
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3854_28685",
    result: "effect2_dropShadow_3854_28685"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.90151,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_3854_28685"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.17613
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.17613
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.513726 0 0 0 0 0.439216 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_3854_28685",
    result: "effect3_dropShadow_3854_28685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_3854_28685",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3854_28685",
    x1: 55.2931,
    y1: 0,
    x2: 55.2931,
    y2: 107.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DD8CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F7F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3854_28685",
    x1: 48.2237,
    y1: 26.1831,
    x2: 61.6434,
    y2: 83.2893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFile);
export default __webpack_public_path__ + "static/media/noFile.e0645a9814171563de23fa90ca26574c.svg";
export { ForwardRef as ReactComponent };